import React, { FC } from 'react';
import { Tooltip } from '@silverfort/sf-components';
import { formatExtraDetailsData } from '@silverfort-nodelibs/common/utils/common';
import { InsightEntity } from '../../api/types/Insights';

interface Props {
    entityData: InsightEntity;
    extraDetailsObj: Record<string, string>;
}

const ExtraDataColumn: FC<Props> = ({ entityData, extraDetailsObj }) => {
    const formattedData = formatExtraDetailsData(entityData, extraDetailsObj);
    return formattedData ? (
        <div className="h-full w-full">
            <Tooltip title={formattedData} onlyOnOverflow>
                <div className="max-w-full text-13 text-gray-800 font-sf">{formattedData}</div>
            </Tooltip>
        </div>
    ) : null;
};

export default ExtraDataColumn;
